<template>
  <div class="home-container">
    <HomeHead :noDownload="true" />
    <ProdDesc />
    <ProdImg />
    <HomeFooter />
  </div>
</template>

<script>
import HomeHead from './components/HomeHead'
import HomeFooter from './components/HomeFooter'
import ProdDesc from './components/ProdDesc'
import ProdImg from './components/ProdImg'

export default {
  name: 'Home',
  components: {
    HomeHead,
    HomeFooter,
    ProdDesc,
    ProdImg,
  },
  computed: {
  }
}
</script>

<style lang="less" scoped>
.home-container {
  min-width: @gb_minWidth;
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei',
    '微软雅黑', Arial, sans-serif;
}

.my-foot {
  overflow: hidden;
  background: #1b2131;
}

.my-foot-list {
  margin-top: 30px;
  line-height: 60px;
}

.my-foot-item {
  margin-left: 110px;
  font-size: 25px;
  color: rgba(255, 255, 255, 0.7);
  &:first-child {
    margin-left: 0;
  }
  i {
    margin-right: 10px;
  }
}

.my-foot-infowrap {
  text-align: center;
  padding-bottom: 20px;
}

.mx-foot-info {
  margin: 10px auto;
  font-size: 12px;
  color: #ddd;
}

.mx-foot-link {
  color: inherit;
  &:hover {
    opacity: 0.5;
  }
}

.mx-foot-split {
  margin: 0 1em;
  opacity: 0.7;
  font-style: normal;
}
</style>
